import { UseToastOptions } from '@chakra-ui/react';
import type { ValidationError } from 'yup';

export const ValidationErrorMessage = (error: ValidationError): UseToastOptions => {
    const description = error.inner.length
        ? error.inner
              // cap to 20 inner errors
              .slice(0, 30)
              .map((err) => err.message)
              .join('\n')
        : error.message;

    return {
        position: 'bottom',
        title: 'Validation Failed',
        description,
        status: 'error',
        duration: 5000,
        isClosable: true
    };
};
